<template>
  <div id="app">
    <router-view  :key="$route.fullPath"/>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
    body {
    }

    #app {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
    }
</style>
